// extracted by mini-css-extract-plugin
export var description = "styles-module--description--e3112";
export var flexContainer = "styles-module--flexContainer--8e31b";
export var imageContainer = "styles-module--imageContainer--f075b";
export var price = "styles-module--price--49c21";
export var productDetails = "styles-module--productDetails--af892";
export var strikethrough = "styles-module--strikethrough--2f48a";
export var title = "styles-module--title--6e84f";
export var variantSelector = "styles-module--variantSelector--614fe";